import axios from 'axios';
import Common from './Common';
export default {
    getRefLink(id) {
        return axios.get(Common.api + 'aff-ref-link/' + id);
    },
    getAffProducts(id,i) {
        return axios.get(Common.api + 'get-aff-personal-queue/' + id+'/'+i);
    },
    getAffsoldProducts(id,logged_user,i) {
        return axios.get(Common.api + 'get-my-sales/' + id + '/' + logged_user + '/' + i);
    },
    getAffsoldProductsCommission(id, i) {
        return axios.get(Common.api + 'my-commission-sources/' + id + '/' + i);
    },
    getChildrenList(id) {
        return axios.get(Common.api + 'get-my-decendants/' + id);
    },
    getTotalProducts(id) {
        return axios.get(Common.api + 'my-affiliating-total/' + id);
    }
}